import React, { Component } from 'react';

export default class NotVerifiedAgeAuth extends Component {
  render() {
    const { profile } = this.props;
    const authUrl = profile == undefined ?
        '' : `${process.env.REACT_APP_AUTH_URL}/ageauths/main.html?auth_level=20&age_limit=19&auth_from=pf&return_url=${profile.get('permalink')}/chat`;

    const authLinkStyle = profile == undefined ? 'none' : 'block';
    return (
      <div id="kakaoContent" className="cont_bridge" role="main">
        <span className="img_404" />
        <strong className="tit_bridge">연령인증을 하지않아서 페이지에 접근할 수 없습니다.</strong>
        <p className="desc_bridge">청소년에 유해한 정보/컨텐츠 등이 포함되어 있을 수 있어 <br />
          정보통신망 이용촉진및 정보보호 등에 관한 법률 및 청소년 보호법에 따라 19세미만의 청소년이 이용할 수 없습니다.</p>
        <br />
        <a className="link_logo" href={authUrl} style={{ display: authLinkStyle }}>
          본인인증 하러가기
        </a>
        <div className="logout_bridge">
          <a href={`${process.env.REACT_APP_KAKAO_ACCOUNT_URL}/logout?continue=${process.env.REACT_APP_SERVICE_HOST}/logged_out`}
            className="link_logout logout" data-tiara-layer="logout"
          >
            로그아웃
          </a>
        </div>
      </div>
    );
  }
}






// WEBPACK FOOTER //
// ./src/components/ErrorContent/NotVerifiedAgeAuth.js